import {FC, useEffect, useState, BaseSyntheticEvent} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Button} from '../../../components/Button/Button'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import {Input} from '../../../components/Input/Input'
import Swal from 'sweetalert2'
import uuid from 'react-uuid'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {EditorQuill} from '../../../components/EditorQuill/EditorQuill'

const QueueConfigContent: FC = () => {
  const [loading, setLoading] = useState(false)
  const [link, setLink] = useState('')
  const [able, setAble] = useState(false)
  const [limitPeople, setLimitPeople] = useState(0)
  const [totalPerGroup, setTotalPerGroup] = useState(0)
  const [limitTime, setLimitTime] = useState(0)
  const [image1, setImage1] = useState<File | null | string>(null)
  const [firstStateImage1, setFirstStateImage1] = useState<File | null | string>(null)
  const [image2, setImage2] = useState<File | null | string>(null)
  const [firstStateImage2, setFirstStateImage2] = useState<File | null | string>(null)
  const [selectedImages, setSelectedImages] = useState<Array<string>>([])
  const [observation, setObservation] = useState('')
  const [termsActive, setTermsActive] = useState(false)
  const [dragOverImage1, setDragOverImage1] = useState(false)
  const [dragOverImage2, setDragOverImage2] = useState(false)

  const [useLocation, setUseLocation] = useState(false)
  const [useMenu, setUseMenu] = useState(false)
  const [useNinegridMenu, setUseNinegridMenu] = useState(false)
  const [externalMenuLink, setExternalMenuLink] = useState('')
  const [useTableManagement, setUseTableManagement] = useState(false)

  const [locationRadius, setLocationRadius] = useState<number>(0)

  const changeQueueConfig = async () => {
    try {
      if (limitPeople < totalPerGroup) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'O total de pessoas por grupo não pode ser maior que o limite de pessoas na fila!',
        })
        return
      } else if (locationRadius < 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Informe uma distância válida para entrar na fila.',
        })
        return
      }
      setLoading(true)
      const res = await POST('/queueReservation/queueConfig', {
        able,
        limitTime,
        limitPeople,
        observation,
        useTerms: termsActive,
        useMenu,
        useNinegridMenu,
        externalMenuLink,
        useLocation,
        limitPeopleGroup: totalPerGroup,
        limitQueue: locationRadius,
        useTableManagement,
      })
      if (res && res.data && res.data) {
        const queueConfig = res.data
        let imagesQueue = []

        if (image1 && image1 !== firstStateImage1) {
          if (
            firstStateImage1 &&
            !firstStateImage1.toString().includes('img.ninegrid.com/exemplo/')
          ) {
            await POST('/upload-images/delete-one', {
              url: firstStateImage1,
            })
          }
          const formData = new FormData()
          formData.append('file', image1)
          formData.append('nameImage', `queue-config-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes && imageRes.image) {
            imagesQueue.push(imageRes.image)
          }
        } else if (image1 && image1 === firstStateImage1) {
          imagesQueue.push(image1)
        }
        if (image2 && image2 !== firstStateImage2) {
          if (
            firstStateImage2 &&
            !firstStateImage2.toString().includes('img.ninegrid.com/exemplo/')
          ) {
            await POST('/upload-images/delete-one', {
              url: firstStateImage2,
            })
          }
          const formData = new FormData()
          formData.append('file', image2)
          formData.append('nameImage', `queue-config-${uuid()}.jpg`)
          formData.append('originalSize', 'true')
          const imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes && imageRes.image) {
            imagesQueue.push(imageRes.image)
          }
        } else if (image2 && image2 === firstStateImage2) {
          imagesQueue.push(image2)
        }

        if (selectedImages[0] && imagesQueue.length < 2) {
          imagesQueue.push(selectedImages[0])
        }
        if (selectedImages[1] && imagesQueue.length < 2) {
          imagesQueue.push(selectedImages[1])
        }
        await POST('/queueReservation/queueImage', {
          images: imagesQueue,
          queueConfigId: queueConfig.id,
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Configuração realizada!',
        }).then(async () => await init())
      } else {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao configurar fila!',
        })
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao configurar fila!',
      })
    }
  }

  const getQueueConfig = async () => {
    try {
      const res = await GET('/queueReservation/queueConfig')
      if (res && res.success && res.data && res.data.length > 0) {
        const queueConfig = res.data[0]
        setAble(queueConfig.able)
        setLimitPeople(queueConfig.limitPeople)
        setLimitTime(queueConfig.limitTime)
        setTotalPerGroup(queueConfig.limitPeopleGroup)
        setObservation(queueConfig.observation)
        setTermsActive(queueConfig.useTerms)
        setUseLocation(queueConfig.useLocation)
        setUseMenu(queueConfig.useMenu)
        setUseNinegridMenu(queueConfig.useNinegridMenu)
        setExternalMenuLink(queueConfig.externalMenuLink)
        setLocationRadius(queueConfig.limitQueue)
        if (queueConfig.useTableManagement !== undefined) {
          setUseTableManagement(queueConfig.useTableManagement)
        }
        setImage1(null)
        setImage2(null)
        setFirstStateImage1(null)
        setFirstStateImage2(null)
        if (queueConfig.images) {
          let urls = []
          const images = queueConfig.images.sort((a: any, b: any) =>
            parseInt(a.id) > parseInt(b.id) ? 1 : parseInt(b.id) > parseInt(a.id) ? -1 : 0
          )
          if (images[0]) {
            if (images[0].url.includes('img.ninegrid.com/exemplo/')) {
              urls.push(images[0].url)
            } else {
              setImage1(images[0].url)
              setFirstStateImage1(images[0].url)
            }
          } else {
            setImage1(null)
            setFirstStateImage1(null)
          }
          if (images[1]) {
            if (images[1].url.includes('img.ninegrid.com/exemplo/')) {
              urls.push(images[1].url)
            } else {
              setImage2(images[1].url)
              setFirstStateImage2(images[1].url)
            }
          } else {
            setImage2(null)
            setFirstStateImage2(null)
          }
          setSelectedImages(urls)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getLink = async () => {
    const appRes = await GET('/appconfig')
    if (appRes && appRes.data) {
      const webapp = appRes.data.find((app: any) => app.type === 'qr')
      let url = ''
      if (webapp) {
        if (process.env.REACT_APP_PROD === '1') {
          url =
            'https://webapp' +
            '.ninegrid.com.br/' +
            window.btoa(webapp.pluginSpace.subdomain) +
            '/queue'
        } else {
          url =
            process.env.REACT_APP_WEBAPP_URL +
            '/' +
            window.btoa(webapp.pluginSpace.subdomain) +
            '/queue'
        }
      }
      setLink(url)
    }
  }

  const init = async () => {
    setLoading(true)
    await getLink()
    await getQueueConfig()
    setLoading(false)
  }

  const selectImage = (url: string) => {
    if (selectedImages.includes(url)) {
      setSelectedImages(selectedImages.filter((i) => i !== url))
    } else {
      if (selectedImages.length < 2) {
        const newSelecteds = selectedImages.map((i) => i)
        newSelecteds.push(url)
        setSelectedImages(newSelecteds)
      }
    }
  }

  // 🔥 DRAG-AND-DROP: Métodos para arrastar imagens da galeria
  const handleDragStart = (e: any, imageUrl: string) => {
    e.dataTransfer.effectAllowed = 'copy'
    e.dataTransfer.setData('imageUrl', imageUrl)
  }

  const handleDragOver = (e: any) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'copy'
  }

  const handleDropImage1 = (e: any) => {
    e.preventDefault()
    setDragOverImage1(false)
    const imageUrl = e.dataTransfer.getData('imageUrl')
    if (imageUrl) {
      setImage1(imageUrl)
    }
  }

  const handleDropImage2 = (e: any) => {
    e.preventDefault()
    setDragOverImage2(false)
    const imageUrl = e.dataTransfer.getData('imageUrl')
    if (imageUrl) {
      setImage2(imageUrl)
    }
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`queue.config`)} </span>
                <BreadCrumbs />
              </h3>
            </div>
            <div className='card-body'>
              {/* Status e Link */}
              <div className='mb-6'>
                <div className='d-flex align-items-center gap-3 mb-4'>
                  <span className='fw-bold fs-6'>{i18n.t(`queue.able`)}</span>
                  <Input
                    checkSwift
                    inputAttr={{
                      type: 'checkbox',
                    }}
                    checked={able}
                    value={able}
                    change={(value: boolean) => setAble(value)}
                  />
                </div>

                <div className='border border-2 border-dashed rounded p-4 bg-light-primary'>
                  <label className='fw-bold fs-6 mb-2 d-block'>
                    <i className='bi bi-link-45deg text-primary me-2'></i>
                    {i18n.t(`queue.link`)}
                  </label>
                  <div className='d-flex gap-2 align-items-center'>
                    <div className='flex-grow-1'>
                      <a
                        href={link}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-primary fw-semibold'
                        style={{
                          fontSize: '0.95rem',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          cursor: 'pointer',
                          display: 'block',
                          border: 'none',
                          background: 'transparent',
                          padding: '0.25rem 0',
                        }}
                        title={link}
                      >
                        {link}
                      </a>
                    </div>
                    <button
                      className='btn btn-sm btn-icon btn-light-primary'
                      type='button'
                      title='Copiar link'
                      onClick={() => {
                        navigator.clipboard.writeText(link)
                        Swal.fire({
                          icon: 'success',
                          title: 'Link copiado!',
                          text: 'O link foi copiado para a área de transferência.',
                          showConfirmButton: false,
                          timer: 1500,
                        })
                      }}
                    >
                      <i className='bi bi-clipboard'></i>
                    </button>
                    <button
                      className='btn btn-sm btn-icon btn-light-success'
                      type='button'
                      title='Compartilhar link'
                      onClick={() => {
                        if (navigator.share) {
                          navigator
                            .share({
                              title: 'Link da Fila',
                              text: 'Entre na fila através deste link',
                              url: link,
                            })
                            .catch(() => {})
                        } else {
                          window.open(
                            `https://wa.me/?text=${encodeURIComponent('Entre na fila: ' + link)}`,
                            '_blank'
                          )
                        }
                      }}
                    >
                      <i className='bi bi-share'></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Card 1: Configurações Básicas */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-gear-fill text-primary me-2'></i>
                    Configurações Básicas
                  </h5>
                </div>
                <div className='card-body'>
                  <div className='row g-4'>
                    <div className='col-md-6 col-xl-4'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        label={i18n.t(`queue.limit_people`)}
                        value={limitPeople}
                        change={(value: number) => setLimitPeople(value)}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`queue.limit_people_text`)}
                      </small>
                    </div>

                    <div className='col-md-6 col-xl-4'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        label={i18n.t(`queue.total_people`)}
                        value={totalPerGroup}
                        change={(value: number) => setTotalPerGroup(value)}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`queue.total_people_text`)}
                      </small>
                    </div>

                    <div className='col-md-6 col-xl-4'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        label={i18n.t(`queue.limit_time`)}
                        value={limitTime}
                        change={(value: number) => {
                          if (Number(value) >= 0) setLimitTime(value)
                          else setLimitTime(0)
                        }}
                      />
                      <small className='text-muted d-block mt-1'>
                        {i18n.t(`queue.limit_time_text`)}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 2: Opções da Fila */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-toggles text-success me-2'></i>
                    Opções da Fila
                  </h5>
                </div>
                <div className='card-body'>
                  <div className='row g-5'>
                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={termsActive}
                          value={termsActive}
                          change={(value: boolean) => setTermsActive(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-file-text me-1'></i>
                            {i18n.t(`queue.use_terms`)}
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            Exigir aceitação de termos ao entrar na fila
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useLocation}
                          value={useLocation}
                          change={(value: boolean) => setUseLocation(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-geo-alt me-1'></i>
                            {i18n.t(`queue.use_location`)}
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            Validar localização do cliente para entrar na fila
                          </p>
                        </div>
                      </div>
                      {useLocation && (
                        <div className='mt-3'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            label='Distância necessária para entrar na fila'
                            value={locationRadius}
                            change={(value: string) => setLocationRadius(parseInt(value))}
                            placeholder='0'
                          />
                          <small className='text-muted d-block mt-1'>Em metros</small>
                        </div>
                      )}
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useMenu}
                          value={useMenu}
                          change={(value: boolean) => setUseMenu(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-card-list me-1'></i>
                            {i18n.t(`queue.use_menu`)}
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            Exibir cardápio para os clientes na fila
                          </p>
                        </div>
                      </div>
                      {useMenu && (
                        <div className='mt-3'>
                          <div className='mb-3'>
                            <label className='fw-bold fs-6 mb-2'>
                              {i18n.t(`queue.use_ninegrid_menu`)}
                            </label>
                            <div className='d-flex gap-3'>
                              <Input
                                inputAttr={{
                                  type: 'newRadio',
                                }}
                                name='use_ninegrid_menu'
                                label='Sim'
                                checked={useNinegridMenu}
                                change={() => setUseNinegridMenu(true)}
                              />
                              <Input
                                inputAttr={{
                                  type: 'newRadio',
                                }}
                                name='use_ninegrid_menu'
                                label='Não'
                                checked={!useNinegridMenu}
                                change={() => setUseNinegridMenu(false)}
                              />
                            </div>
                          </div>
                          <Input
                            inputAttr={{
                              type: 'default',
                            }}
                            label={i18n.t(`queue.external_menu_link`)}
                            value={externalMenuLink}
                            disabled={useNinegridMenu || !useMenu}
                            change={(value: string) => setExternalMenuLink(value)}
                          />
                        </div>
                      )}
                    </div>

                    <div className='col-lg-4'>
                      <div className='d-flex align-items-start gap-3'>
                        <Input
                          checkSwift
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          checked={useTableManagement}
                          value={useTableManagement}
                          change={(value: boolean) => setUseTableManagement(value)}
                        />
                        <div className='flex-grow-1'>
                          <label className='fw-bold fs-6 mb-1'>
                            <i className='bi bi-table me-1'></i>
                            Habilitar Gestão de Mesas
                          </label>
                          <p className='text-muted fs-7 mb-0'>
                            Quando habilitado, oferece sugestões de alocação de mesas ao confirmar
                            posições da fila
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 3: Observações */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-chat-left-text text-info me-2'></i>
                    {i18n.t(`queue.observation`)}
                  </h5>
                </div>
                <div className='card-body'>
                  <EditorQuill
                    value={observation}
                    change={(value: string) => setObservation(value)}
                    height={200}
                  />
                  <small className='text-muted d-block mt-2'>
                    Adicione observações importantes que serão exibidas aos clientes
                  </small>
                </div>
              </div>

              {/* COMENTADO: Card 4: Imagens - Definição de imagens */}
              <div className='card mb-5 shadow-sm'>
                <div className='card-header bg-light d-flex justify-content-between align-items-center'>
                  <h5 className='card-title fw-bold mb-0'>
                    <i className='bi bi-image text-danger me-2'></i>
                    {i18n.t(`queue.image_title`)}
                  </h5>
                  <span className='badge badge-light-primary'>
                    {selectedImages.length} / 2 selecionadas
                  </span>
                </div>
                <div className='card-body'>
                  <p className='text-muted mb-4'>
                    {i18n.t(`queue.image_text`)}
                  </p>
                  
                  <div className='border border-2 border-dashed rounded p-4 mb-4 bg-light-primary'>
                    <h6 className='fw-bold text-gray-800 mb-3'>
                      <i className='bi bi-cloud-upload text-primary me-2'></i>
                      Enviar Imagens Personalizadas
                    </h6>
                    <p className='text-muted fs-8 mb-3'>
                      <i className='bi bi-info-circle me-1'></i>
                      Você também pode arrastar imagens da galeria abaixo para as posições
                    </p>
                    <div className='row g-3'>
                      <div className='col-md-6'>
                        <div
                          onDragOver={handleDragOver}
                          onDrop={handleDropImage1}
                          onDragEnter={() => setDragOverImage1(true)}
                          onDragLeave={() => setDragOverImage1(false)}
                          style={{
                            padding: '12px',
                            borderRadius: '6px',
                            backgroundColor: dragOverImage1 ? '#e8f5e9' : 'transparent',
                            border: dragOverImage1 ? '2px solid #50cd89' : 'none',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <Input
                            inputAttr={{
                              type: 'image',
                            }}
                            label={`${i18n.t(`queue.image`)} 1`}
                            value={image1}
                            change={(value: BaseSyntheticEvent) =>
                              setImage1(value ? value.target.files[0] : null)
                            }
                          />
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div
                          onDragOver={handleDragOver}
                          onDrop={handleDropImage2}
                          onDragEnter={() => setDragOverImage2(true)}
                          onDragLeave={() => setDragOverImage2(false)}
                          style={{
                            padding: '12px',
                            borderRadius: '6px',
                            backgroundColor: dragOverImage2 ? '#e8f5e9' : 'transparent',
                            border: dragOverImage2 ? '2px solid #50cd89' : 'none',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <Input
                            inputAttr={{
                              type: 'image',
                            }}
                            label={`${i18n.t(`queue.image`)} 2`}
                            value={image2}
                            change={(value: BaseSyntheticEvent) =>
                              setImage2(value ? value.target.files[0] : null)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='border border-2 border-dashed rounded p-4 bg-light-success'>
                    <h6 className='fw-bold text-gray-800 mb-3'>
                      <i className='bi bi-images text-success me-2'></i>
                      Galeria de Imagens (selecione até 2)
                    </h6>
                    <div className='row g-3'>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                        <div key={item} className='col-6 col-sm-4 col-md-3 col-xl-2'>
                          <div
                            draggable
                            onDragStart={(e) =>
                              handleDragStart(e, `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`)
                            }
                            className='position-relative cursor-pointer rounded overflow-hidden shadow-sm hover-shadow-lg transition'
                            style={{
                              border: selectedImages.includes(
                                `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                              )
                                ? '3px solid #50cd89'
                                : '2px solid #e4e6ef',
                              aspectRatio: '4/3',
                              transition: 'all 0.2s ease',
                              cursor: 'grab',
                            }}
                            onClick={() =>
                              selectImage(`https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`)
                            }
                          >
                            <img
                              style={{width: '100%', height: '100%', objectFit: 'cover', userSelect: 'none'}}
                              src={`https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`}
                              alt={`Exemplo ${item}`}
                              draggable={false}
                            />
                            {selectedImages.includes(
                              `https://s3.amazonaws.com/img.ninegrid.com/exemplo/${item}.png`
                            ) && (
                              <>
                                <div 
                                  className='position-absolute top-0 start-0 w-100 h-100'
                                  style={{backgroundColor: 'rgba(80, 205, 137, 0.15)'}}
                                ></div>
                                <div className='position-absolute top-0 end-0 m-2'>
                                  <i className='bi bi-check-circle-fill text-success fs-2'></i>
                                </div>
                              </>
                            )}
                            <div className='position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100' style={{backgroundColor: 'rgba(0,0,0,0.3)', transition: 'opacity 0.2s'}}>
                              <small className='text-white fw-bold'>
                                <i className='bi bi-hand-index me-1'></i>Arrastar
                              </small>
                            </div>
                            <div className='position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white text-center py-1'>
                              <small className='fw-bold'>Imagem {item}</small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              

              {/* Botão Salvar */}
              <div className='d-flex justify-content-end pt-4 border-top'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={8}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => changeQueueConfig()}
                  btnClass='fw-bolder'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const QueueConfig: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`queue.config`), path: 'queue/config', isActive: true},
        ]}
      >
        {i18n.t(`queue.config`)}
      </PageTitle>
      <QueueConfigContent />
    </>
  )
}

export {QueueConfig}
